import { render, staticRenderFns } from "./ListItemCate.vue?vue&type=template&id=5d631321&scoped=true"
import script from "./ListItemCate.vue?vue&type=script&lang=js"
export * from "./ListItemCate.vue?vue&type=script&lang=js"
import style0 from "./ListItemCate.vue?vue&type=style&index=0&id=5d631321&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d631321",
  null
  
)

export default component.exports